<template>
  <component
    v-bind="$attrs"
    v-on="$listeners"
    :is="th ? 'th' : 'td'"
    :class="{ vertical, horizontal, 'break-word': breakWord }"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'Cell',
  props: {
    th: {
      type: Boolean,
    },
    /** 縦固定 */
    vertical: {
      type: Boolean,
    },
    /** 横固定 */
    horizontal: {
      type: Boolean,
    },
    /** 文字を改行するか */
    breakWord: {
      type: Boolean,
    },
  },
}
</script>

<style lang="postcss" scoped>
.horizontal {
  position: sticky;
  z-index: 2;
}
.vertical {
  position: sticky;
  z-index: 3;
}
.horizontal.vertical {
  z-index: 4;
}

.break-word {
  white-space: normal;
  word-break: normal;
}

th,
td {
  &.horizontal:not(:last-child)::after {
    /** clear dotted line */
    width: 0;
  }
}

th {
  &.horizontal {
    border-right: 1px solid var(--white);
  }
}

td {
  &.horizontal {
    border-right: 1px solid var(--border-color);
  }
}

tr:first-child th {
  top: 0;
}
</style>
